import { Component, ViewEncapsulation, Inject, ElementRef } from "@angular/core";
import { DialogPanelComponentContent } from "@toro/common/shared/models/dialogs/DialogPanelComponentContent";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { UserSantanderService } from '@toro/common/shared/services/users/user-santander.service';
import { TrackingsService } from '../../../services/tracking.service';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { environment } from "@hub-workspace/apps/stock/src/environments/environment";
import { filter, first } from 'rxjs/operators';

@Component({
  selector: "checkout-guarantee-warning-aside-panel",
  templateUrl: "./checkout-guarantee-warning-aside-panel.component.html",
  styleUrls: ["checkout-guarantee-warning-aside-panel.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CheckoutGuaranteeWarningSidePanelComponent extends DialogPanelComponentContent {
  public isNewBrand = environment.isNewBrand;
  private isGuaranteeAccepted: boolean;
  private hasSantanderIntegrated: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public elementRef: ElementRef,
    private dialogReference: MatDialogRef<CheckoutGuaranteeWarningSidePanelComponent>,
    private tracking: TrackingsService,
    private store: Store<AppState>,
    private userSantanderService: UserSantanderService
  ) {
    super(elementRef, true);

    this.checkSantanderIntegration();

    const scenario = this.getScenario();
    this.tracking.sendMetricsToMixpanel(ActionEventsEnum.MODAL_OPENED, {
      'Product Area Origin': 'Bolsa',
      'Scenario': scenario,
      'Step': 'Checkout',
      'Time Responsável': 'Roebling',
      'Text': 'Utilização da garantia',
    });
  }

  /**
   * Retorna o scenario baseado no tipo de operação e integração Santander
   */
  private getScenario(): string {
    if (this.hasSantanderIntegrated && !this.data.stock.isDayTrade) {
      return 'Swing trade limite operacional integrado';
    }
    return this.data.stock.isDayTrade ? 'Day Trade' : 'Swing Trade';
  }

  /**
   * Verifica se o usuário tem limite operacional Santander integrado
   */
  private checkSantanderIntegration(): void {
    this.store.select((state) => state.authentication.currentUser).pipe(
      filter((user) => !!user && !!user.cblc),
      first()
    ).subscribe((user) => {
      this.userSantanderService.getSantanderOperationalLimit(user.cblc).pipe(
        first()
      ).subscribe({
        next: (santanderLimit) => {
          this.hasSantanderIntegrated = santanderLimit?.hasIntegrated && santanderLimit?.accept;
        },
        error: () => {
          this.hasSantanderIntegrated = false;
        }
      });
    });
  }

  public acceptGuarantee() {
    const scenario = this.getScenario();
    this.tracking.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
      'Product Area Origin': 'Bolsa',
      'Element': 'Botão concordar e seguir para revisão',
      'Group': 'Modal',
      'Scenario': scenario,
      'Step': 'Checkout',
      'Time Responsável': 'Roebling',
    });

    this.isGuaranteeAccepted = true;
    this.close(this.dialogReference, this.isGuaranteeAccepted);
  }

  public redirectExternal(url: string) {
    window.location.href = `${url}`;
  }

  public redirectBack() {
    this.close(this.dialogReference, null);
  }
}
